import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { FormInput } from '../../../../components/FormInput/FormInput';
import { PasswordInput } from '../../../../components/FormInput/PasswordInput';

import classes from './RedesignEmailAndPasswordInputs.module.scss';

export const RedesignEmailAndPasswordInputs = ({
  disabled,
  emailErrorMessageMap,
  passwordErrorMessageMap,
  emailError,
  passwordError,
  onChangeEmail,
  onChangePassword,
  className,
  hideErrors,
  type,
}: {
  disabled: boolean;
  emailErrorMessageMap?: Record<string, string>;
  passwordErrorMessageMap?: Record<string, string>;
  emailError?: string;
  passwordError?: string;
  onChangeEmail?: (email: string) => void;
  onChangePassword?: (password: string) => void;
  className?: string;
  hideErrors?: boolean;
  type: 'sign_up' | 'log_in';
}) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      <div className={classes.formRow}>
        <label className={classNames(classes.label)} htmlFor="email">
          {t('common.email')}
          {!!emailError && <span className={classes.requiredIndicatorError}>*</span>}
        </label>
        <FormInput
          autoComplete="email"
          className={classNames({ [classes.errorStyleInput]: !!emailError })}
          dataTestId={type === 'sign_up' ? 'signup-enter-email-field' : 'login-enter-email-field'}
          disabled={disabled}
          errorMessageMap={emailErrorMessageMap}
          hideErrors={hideErrors}
          id="email"
          name="email"
          placeholder={t('auth.enterEmail')}
          size={'md'}
          type="email"
          onChange={(event) => onChangeEmail && onChangeEmail(event.target.value)}
        />
      </div>

      <div className={classes.formRow}>
        <label className={classNames(classes.label)} htmlFor="password">
          {t('forms.password')}
          {!!passwordError && <span className={classes.requiredIndicatorError}>*</span>}
        </label>
        <PasswordInput
          className={classNames(classes.formPassword, { [classes.errorStyleInput]: !!passwordError })}
          dataTestId={type === 'sign_up' ? 'signup-enter-password-field' : 'login-enter-password-field'}
          disabled={disabled}
          errorMessageMap={passwordErrorMessageMap}
          hideErrors={hideErrors}
          id="password"
          minLength={6}
          name="password"
          placeholder={t('auth.enterPassword')}
          size={'md'}
          onChange={(event) => onChangePassword && onChangePassword(event.target.value)}
        />
      </div>
    </div>
  );
};
